import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import InStudio1 from '../assets/Services/InStudio.png';
import InStudio2 from '../assets/Services/InStudio_2.png';
import '../styles/ServicesPage.css'

const GroupLessonsPage = () => (
  <div className='service-page container'>
    <Breadcrumbs />
    <h1>In-Studio Music Lessons</h1>

    {/* Row 1 */}
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '40px',
        gap: '20px',
        padding: '0 40px 0 40px',
      }}
    >
      <div style={{ flex: '1 1 300px', textAlign: 'center' }}>
        <img
          src={InStudio2}
          alt='Instructor and Student In Studio Lessons'
          style={{
            width: '100%',
            borderRadius: '10px',
            height: 'auto',
          }}
        />
      </div>
      <div
        style={{
          flex: '2 1 400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <p style={{ textAlign: 'center', lineHeight: '1.6' }}>
          For students looking to learn in a professional setting, our in-studio lessons offer an immersive learning experience. Whether you're a beginner or an advanced musician, our guitar and drum lessons are designed to meet your individual needs. Lessons take place in a fully-equipped music studio, providing access to professional-grade instruments and gear.
        </p>
      </div>
    </div>

    {/* Row 2 */}
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '40px 0 40px 0',
        gap: '20px',
        padding: '0 40px 0 40px',
      }}
    >
      <div
        style={{
          flex: '2 1 400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <p style={{ textAlign: 'center', lineHeight: '1.6' }}>
          With 30-minute and 45-minute session options, students benefit from hands-on guidance, structured curriculum, and real-world playing experience. In-studio lessons also provide an excellent opportunity to collaborate with other students, fostering creativity and musical growth. Take your skills to the next level in a space designed for serious learning and fun.
        </p>
      </div>
            <div style={{ flex: '1 1 300px', textAlign: 'center' }}>
        <img
          src={InStudio1}
          alt='Instructor and Student In Studio Lessons'
          style={{
            width: '100%',
            borderRadius: '10px',
            height: 'auto',
          }}
        />
      </div>
    </div>

    <p className='service-closing'>
      Our approach ensures that every student receives the support and guidance they need to grow as musicians, whether they want to play for fun, perform in a band, or prepare for professional opportunities. With a flexible curriculum, we incorporate each student’s favorite music styles and genres to make learning an exciting and rewarding experience!
    </p>
    <Link to='/contact' className='btn btn-primary'>Book A Lesson</Link>
  </div>
);

export default GroupLessonsPage;
